var videos = function () {
    Array.from(document.querySelectorAll('iframe[height]'), function (video) {
        var ratio = video.width / video.height;
        video.style.setProperty('--ratio', ratio + '');
    });
};
export default videos;
